export const FRESHMAN = 'FRESHMAN';
export const SOPHOMORE = 'SOPHOMORE';
export const JUNIOR_VARSITY = 'JUNIOR_VARSITY';
export const VARSITY = 'VARSITY';
